import getCookieValue from 'src/helpers/getCookieValue';

const getAECID = (): string | undefined => {
  const ecidValue = getCookieValue('s_ecid');
  // Strip MCMID%7C from string for Adobe Experience Cloud ID
  return ecidValue ? ecidValue.split('MCMID%7C')[1] : undefined;
};

export default getAECID;
